export enum RouteParam {
  responsePoints = 'responsePoints',
}
